import { Component, ViewChild } from '@angular/core';
import { HolidayService } from '../../../Model/Holiday/holiday.service';
import { CommonService } from '../../../Model/Common/common.service';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ComboService } from '../../../Model/Combo/combo.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import moment from 'moment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';

interface ClientHoliday {
  Date: string
  ESS_CompanyHolidayMasterId: number
  ESS_HolidayMasterId: number
  ESS_StateHolidayMasterID: number
  HolidayName: string
  StateName: string
  TypesOfLeave: string
  Year: string
}

@Component({
  selector: 'app-client-holiday',
  standalone: true,
  imports: [DataTablesModule, CommonModule, FormsModule, NgbNavModule, NgSelectModule, RouterModule, LoaderComponent],
  templateUrl: './client-holiday.component.html',
  styleUrl: './client-holiday.component.scss'
})
export class ClientHolidayComponent {
  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;
  active = 1;
  ClientHolidayData: ClientHoliday[] = [];
  isDisabled: boolean = false;
  isGDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  ClientIdObjSelected = [] as any;

  DisablesFilter = {
    Year: false,
    State: false,
  }

  filter = {
    SelectType: 4,
    ClientId: null as any,
    StateId: null,
    Year: null,
    TypesOfLeave: null,
    ClientIdObj: null as any,
    HistoryYear: 0,
    ESS_ClientOnStateHolidayMasterId: null as any
  }
  ClientsFilter = [] as any;
  StatesFilter = [] as any;

  Years = [] as any;
  TypesOfLeaves = ['NA', 'Compulsory', 'Optional'];
  HolidayMappingDetail = {
    ESS_ClientHolidayMasterID: 0,
    SelectType: 'insert',
    ESS_ClientHolidayMaster: [] as any,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private toast: ToastService,
    private holiday: HolidayService,
    private combo: ComboService,
    private modalService: NgbModal,
    private utility: UtilityService,
    private router: Router,
    private route: ActivatedRoute,
    protected common: CommonService,
    private tooltip: TooltipService
  ) {
    this.common.getPageRights();
    this.route.params.subscribe(params => this.filter.ESS_ClientOnStateHolidayMasterId = parseInt(params['id']));
    this.SelectDate('RegistrationDate', null, null);
    if (this.filter.ESS_ClientOnStateHolidayMasterId > 0) {
      this.DisablesFilter = {
        Year: true,
        State: true,
      }
    }
    this.dtoptions = { ...this.common.commonDToptions };
  }


  ngOnInit(): void {
    if (this.filter.ESS_ClientOnStateHolidayMasterId > 0) {
      this.GetClientHoliday();
    }
    const currentYear = new Date().getFullYear();
    this.filter.HistoryYear = currentYear;
    this.ComboLoad('State');
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }


  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({ 'Combotype': Combotype, 'BranchId': 0, 'ClientId': 0, 'SiteId': 0, 'DesignationId': 0, 'EmpType': null, 'StateId': this.filter.StateId, 'DistrictId': 0, 'EmpMasterID': 0, Year: this.filter.Year }).subscribe({
      next: (response) => {
        if (Combotype == 'State') {
          this.StatesFilter = response.ComboLoad;
        } else if (Combotype == 'StateWiseClient') {
          this.ClientsFilter = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {


      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetClientHoliday() {
    this.isDisabled = true;
    this.isGDisabled = true;
    try {
      if (this.filter.ClientIdObj.length) {
        this.filter.ClientId = this.filter.ClientIdObj.toString();
      } else {
        this.filter.ClientId = null;
      }
      this.isDisabled = false;
      this.isGDisabled = false;
    } catch (e) {
      this.isDisabled = false;
      this.isGDisabled = false;
    }


    //this.filter.ClientId = 0;
    this.holiday.GetClientHoliday(this.filter).subscribe({
      next: (response) => {
        if (this.filter.ESS_ClientOnStateHolidayMasterId > 0) {
          this.HolidayData = response
          if (this.filter.Year == null) {
            this.filter.Year = response.Table1[0].Year;
          }

          if (this.filter.StateId == null || this.filter.StateId == 0) {
            this.filter.StateId = response.Table1[0].Stateid;
          }

          if (this.filter.ClientIdObj == null || this.filter.ClientIdObj.length == 0) {
            this.ComboLoad('StateWiseClient');
            this.filter.ClientIdObj = response.Table1.map((e: any) => e.ClientId.toString()).map(Number);
          }

          //this.ClientIdObjSelected = response.Table1.map((e: any) => e.ClientId.toString()).map(Number);
          this.HolidayMappingDetail.SelectType = 'update';
        }
        this.HolidayMappingDetail.ESS_ClientHolidayMaster = response.Table;
        this.ClientHolidayData = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  HolidayData = [] as any

  // loadClientHoliday() {
  //   this.isDisabled = true;
  //   this.holiday.GetClientHoliday({ SelectType: this.filter.SelectType, Year: this.filter.HistoryYear, ESS_ClientOnStateHolidayMasterID: this.ESS_ClientOnStateHolidayMasterID }).subscribe({
  //     next: (response) => {
  //       this.HolidayData = response
  //       this.filter.Year = response.Table1[0].Year;

  //       this.filter.StateId = response.Table1[0].Stateid;
  //       this.ComboLoad('StateWiseClient');
  //       this.filter.ClientIdObj = response.Table1.map((e: any) => e.ClientId)
  //       const clientIdsString = response.Table1.map((e: any) => e.ClientId)[0];
  //       const clientIdsArray = clientIdsString.split(',').map(Number);
  //       this.filter.ClientIdObj = clientIdsArray;
  //       this.HolidayMappingDetail.ESS_ClientHolidayMaster = response.Table;
  //       this.ClientHolidayData = Object.values(response.Table)
  //       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {


  //         dtInstance.destroy();
  //         // Call the dtTrigger to rerender again
  //         this.dtTrigger.next(null);


  //       });
  //       this.HolidayMappingDetail.SelectType = "Update";


  //       this.isDisabled = false;
  //       this.HolidayMappingDetail.SelectType = "Update";


  //       this.isDisabled = false;
  //     },
  //     complete: () => { },
  //     error: (error) => {
  //       this.isDisabled = false;
  //     },
  //   });
  // }

  Validate(form: any) {
    if (form.valid) {
      if (this.filter.Year && this.filter.StateId && this.filter.ClientIdObj && this.filter.ClientIdObj.length > 0) {
        this.GetClientHoliday();
      }
    }
    else {
      form.submitted = true;
    }
  }

  async SaveClientHoliday() {
    await this.common.getPageRights();
    if (this.filter.Year == null || this.filter.Year == '') {
      this.toast.show({ message: 'Please select year', type: toastTypeEnum.warning });
    } else if (this.filter.StateId == null || this.filter.StateId == '' || this.filter.StateId == 0 || this.filter.StateId == '0') {
      this.toast.show({ message: 'Please select state', type: toastTypeEnum.warning });
    } else if (this.filter.ClientIdObj == null || this.filter.ClientIdObj == '' || this.filter.ClientIdObj.length == 0 ) {
      this.toast.show({ message: 'Please select client', type: toastTypeEnum.warning });
    }else{
      if (this.HolidayMappingDetail.ESS_ClientHolidayMaster.length > 0) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
  
        modalRef.componentInstance.Message = this.HolidayMappingDetail.ESS_ClientHolidayMaster.filter((e: any) => this.common.ToLowerCase(e.TypesOfLeave) == 'compulsory' || this.common.ToLowerCase(e.TypesOfLeave) == 'optional').length > 0 ? 'Do you want to save?' : 'All NA Holiday Type Will be Deleted. Do you want to delete?';
        modalRef.result.then((result: any) => {
          if ((this.common.PageRight.IsAdd && this.filter.ESS_ClientOnStateHolidayMasterId == 0) || (this.common.PageRight.IsEdit && this.filter.ESS_ClientOnStateHolidayMasterId > 0)) {
            if (result) {
              this.isDisabled = true;
  
              this.HolidayMappingDetail.ESS_ClientHolidayMaster.forEach((element: any) => {
                element.ESS_ClientWiseStateHolidayMasterID = this.filter.ESS_ClientOnStateHolidayMasterId;
                element.Year = this.filter.Year;
                element.StateId = this.filter.StateId;
                element.ClientId = this.filter.ClientIdObj.toString();
              });
  
              this.HolidayMappingDetail.ESS_ClientHolidayMaster.forEach((element: any) => {
                element.ESS_ClientWiseStateHolidayMasterID = this.filter.ESS_ClientOnStateHolidayMasterId;
                element.Year = this.filter.Year;
                element.StateId = this.filter.StateId;
                element.ClientId = this.filter.ClientIdObj.toString();
              });
  
              this.holiday.SaveClientHoliday(this.HolidayMappingDetail).subscribe({
                next: (response) => {
                  if (response.Error_Code == '386' || response.Error_Code == '387') {
                    console.log(response);
                    this.filter.ClientId = null;
                    this.filter.StateId = null;
                    this.filter.ClientIdObj = null;
                    const modalRef = this.modalService.open(AlertSuccessComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => {
                      if (result) {
                        this.close();
                      }
                    });
                  }
                  else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                  }
                  this.isDisabled = false;
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            }
          } else {
            this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
          }
        }).catch(() => {
          // Modal dismissed
        });
      } else {
        this.toast.show({ message: 'Please select holidays', type: toastTypeEnum.warning });
      }
    }
  }

  ClearHolidays() {
    this.filter.ClientIdObj = [];
    this.ClientsFilter = []
    this.ClientHolidayData = Object.values([]);
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next(null);
    });
    //this.ClientHolidayDataTable.LoadData(this.HolidayMappingDetail.ESS_ClientHolidayMaster)
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  CheckAll(event: any, Type: String) {
    if (Type == 'Client') {
      if (event.target.checked) {
        this.filter.ClientIdObj = this.ClientsFilter.filter((e: any) => e.ESS_ClientOnStateHolidayMasterId == this.filter.ESS_ClientOnStateHolidayMasterId || e.ESS_ClientOnStateHolidayMasterId == null || e.ESS_ClientOnStateHolidayMasterId == 0).map((e: any) => e.ClientGroupMasterID);
      } else {
        this.filter.ClientIdObj = [];
      }
    }
  }

  CheckDiselect() {
    if (this.filter.ClientIdObj != null) {
      const ClientIdObjfilter = [] as any;
      this.filter.ClientIdObj.forEach((element: any) => {
        if (this.ClientsFilter.filter((e: any) => e.IsClientMapped == 'Mapped' && e.ESS_ClientOnStateHolidayMasterId != this.filter.ESS_ClientOnStateHolidayMasterId).map((e: any) => e.ClientGroupMasterID).filter((e: any) => e == element).length == 0) {
          ClientIdObjfilter.push(element);
        }
      });
      this.filter.ClientIdObj = ClientIdObjfilter;
    }
  }

  close(){
    this.router.navigate(['/master/holiday/client']);
  }
}
